import React, { Component } from 'react'

const RETRY_KEY = 'checkout_chunk_retry'

function isChunkLoadError(error) {
    if (!error) return false
    const message = (error.message || '').toLowerCase()
    const name = (error.name || '').toLowerCase()
    return name === 'chunkloaderror'
        || message.includes('loading chunk')
        || message.includes('loading css chunk')
        || message.includes('failed to fetch dynamically imported module')
        || (message.includes('failed to fetch') && name === 'typeerror')
}

class CheckoutErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        console.error('Checkout failed to load:', error, errorInfo)

        try {
            const alreadyRetried = sessionStorage.getItem(RETRY_KEY)
            if (!alreadyRetried) {
                sessionStorage.setItem(RETRY_KEY, '1')
                window.location.reload()
                return
            }
        } catch (_) {
            // sessionStorage unavailable (private browsing, etc.) — fall through to error UI
        }
    }

    handleRefresh = () => {
        try { sessionStorage.removeItem(RETRY_KEY) } catch (_) { /* noop */ }
        window.location.reload()
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '40px 20px',
                    textAlign: 'center',
                    maxWidth: '500px',
                    margin: '0 auto'
                }}>
                    <h2 style={{ marginBottom: '16px' }}>
                        Something went wrong loading checkout.
                    </h2>
                    <p style={{ marginBottom: '24px', color: '#555' }}>
                        Please refresh the page to try again. If the problem persists, contact us for help.
                    </p>
                    <button
                        onClick={this.handleRefresh}
                        style={{
                            padding: '12px 24px',
                            fontSize: '16px',
                            backgroundColor: '#c41230',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Refresh Page
                    </button>
                </div>
            )
        }

        return this.props.children
    }
}

export { isChunkLoadError, RETRY_KEY }
export default CheckoutErrorBoundary
